import { useCallback, useEffect, useState } from 'react';
import {
  DEFAULT_WORKSPACE_PAGE_SECTION_STATE,
  readWorkspacePageSectionState,
  type WorkspacePageSectionId,
  type WorkspacePageSectionState,
  writeWorkspacePageSectionState,
} from './workspacePageSectionStorage';

export const useWorkspacePageSections = (workspaceId: string | undefined) => {
  const [sections, setSections] = useState<WorkspacePageSectionState>(
    DEFAULT_WORKSPACE_PAGE_SECTION_STATE,
  );

  useEffect(() => {
    if (!workspaceId) {
      setSections({ ...DEFAULT_WORKSPACE_PAGE_SECTION_STATE });
      return;
    }

    setSections(readWorkspacePageSectionState(workspaceId));
  }, [workspaceId]);

  const setSectionExpanded = useCallback(
    (sectionId: WorkspacePageSectionId, expanded: boolean) => {
      if (!workspaceId) return;

      setSections((prev) => {
        const next = { ...prev, [sectionId]: expanded };
        writeWorkspacePageSectionState(workspaceId, next);
        return next;
      });
    },
    [workspaceId],
  );

  return { sections, setSectionExpanded };
};
